// extracted by mini-css-extract-plugin
export var chevronIcon = "_ce-2";
export var teamName = "_ce-1";
export var teamSwitcherButton = "_ce-0";